import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { ContractDetails, Contracts, OrganizeContractRequest, SingleContract } from '../../models/contracts';
import { UserInfo } from '../../models/user-info.model';
import { UserUtilsService } from '../user/user-utils.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private apiUser: string = "";
  private contractSelected: Subject<any> = new Subject()
  contractEvent$ = this.contractSelected.asObservable()
  currentContract: UserInfo | undefined
  contracts: Contracts;

  constructor(
    private http: HttpClient,
    private userUtilsService: UserUtilsService
  ) {
    this.apiUser = environment.apiUser;
    const userInfo = this.userUtilsService.getUserInfoSessionStorage()
    const contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
  }

  getAllContracts(): Observable<Contracts> {
    return this.http.get<Contracts>(`${this.apiUser}/dashboard/contracts`);
  }

  organizeContracts(contracts: OrganizeContractRequest[]): Observable<any> {
    return this.http.post<any>(`${this.apiUser}/dashboard/contracts/order`,
      contracts
    )
  }

  downloadContractReport(contractId: string | number) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', '*/*');
    return this.http.get(`${this.apiUser}/reports/contract/${contractId}`, {headers: headers, responseType: 'blob'});
  }

  downloadPDFdesposits(contractId: string | number, idReferenceContract: string | number) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', '*/*');
    return this.http.get(`${this.apiUser}/reports/contract/${contractId}/${idReferenceContract}/howDeposit`, {headers: headers, responseType: 'blob'});
  }

  getAccuntDataInformation(contractId: any): Observable<ContractDetails> {
    return this.http.get<ContractDetails>(`${this.apiUser}/contracts/data/${contractId}`)
  }

  updateContract(value: any) {
    this.contractSelected.next(value)
  }

  getContracts(): Contracts {
    return this.contracts
  }

  setContracts(value: any) {
    this.contracts = value;
  }

  getCurrentContract(): UserInfo | undefined {
    return this.currentContract;
  }
  setCurrentContract(value: UserInfo | undefined): void {
    this.currentContract = value;
  }

  changeAliasApiCall(contract: SingleContract) {
    return this.http.post(`${this.apiUser}/dashboard/contracts/update/alias`, {
      contractId: contract.contractId,
      alias: contract.alias
    })
  }
}


